import { __decorate } from "tslib";
import lang from '@blade-sxp/portrait-management/lang/index';
import InputSearch from '@blade-sxp/portrait-management/components/input-search.vue';
import VehicleTable from '@blade-sxp/portrait-management/pages/components/vehicle-table.vue';
import SecondCertification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { queryVehiclePageList, batchDeleteAutomobiles, vehicleExport } from '@blade-sxp/portrait-management/api/vehicle';
import { LibraryTypeEnum, PageQueryTypeEnum, VehicleTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { cloneDeep } from 'lodash';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import { SYSTEMCODE } from '@blade/common/constants/code';
import { PortraitManagementDataModule } from '@blade-sxp/portrait-management/store/index';
const Webapi = {
    queryVehiclePageList,
    batchDeleteAutomobiles,
    vehicleExport,
};
let default_1 = class default_1 extends Vue {
    // 权限级别
    permissionlevel = permissionlevel;
    systemCode = SYSTEMCODE;
    // 查询表单
    queryForm = {
        keyword: '',
    };
    // 分页
    paginationParams = {
        page: 1,
        size: 10,
        total: 0,
    };
    lastPaginationParams = null;
    loading = false;
    exportLoading = false;
    // 列表数据
    listData = [];
    selectionList = [];
    secondCertificationDialogVisible = false;
    get hasBacthDeleteButton() {
        return this.selectionList.length > 0;
    }
    paginationParamsChange() {
        // 加载策略 页码和页面尺寸发生变化时重新加载列表
        if (!this.lastPaginationParams)
            return this.getList();
        let curr = this.paginationParams;
        let last = this.lastPaginationParams;
        if (curr.page !== last.page || curr.size !== last.size)
            this.getList();
    }
    // 刷新列表
    created() {
        PortraitManagementDataModule.getAutomobileTypeOrColor(VehicleTypeEnum.AUTOMOBILE_TYPE);
        PortraitManagementDataModule.getAutomobileTypeOrColor(VehicleTypeEnum.AUTOMOBILE_COLOR);
        this.loading = true;
        this.$router.onReady(() => {
            const query = this.$route.query;
            this.paginationParams.libIds = [+query.libId];
            this.getList();
        });
    }
    // 获取数据
    async getList() {
        if (!this.paginationParams)
            return;
        this.loading = true;
        console.log(this.queryForm.keyword);
        try {
            let result = await Webapi.queryVehiclePageList({
                ...this.paginationParams,
                keywords: this.queryForm.keyword,
            });
            this.paginationParams.total = result.total;
            this.listData = result.list;
            this.lastPaginationParams = cloneDeep(this.paginationParams);
        }
        catch (error) {
            console.log('getList error', error);
        }
        this.loading = false;
    }
    // 刷新列表
    refreshList() {
        if (!this.paginationParams)
            return;
        this.listData = [];
        if (this.paginationParams.page !== 1)
            this.paginationParams.page = 1;
        else
            this.getList();
    }
    async secondCertificationSuccess() {
        this.exportLoading = true;
        try {
            let result = await Webapi.vehicleExport({
                automobileIds: this.selectionList.map((s) => s.automobileId.toString()),
            });
            window.location.href = result;
        }
        catch (error) {
            console.log('handleExportFunc error', error);
        }
        this.exportLoading = false;
    }
    // 监听导出
    async handleExportFunc() {
        this.secondCertificationDialogVisible = true;
    }
    handleNew() {
        const query = this.$route.query;
        this.$router.push({ name: 'vehicleCreate', query: { ...query, type: PageQueryTypeEnum.CREATE } });
    }
    handleNewCommand(e) {
        if (e === 'singleVehicle') {
            this.handleNew();
        }
        else if (e === 'batchImport') {
            const query = this.$route.query;
            console.log(query, { ...query, libType: LibraryTypeEnum.AUTO_FEATURE });
            this.$router.push({ name: 'vehicleImport', query: { ...query, libType: LibraryTypeEnum.AUTO_FEATURE } });
        }
    }
    handleSelectionFunc(selection) {
        this.selectionList = selection;
    }
    async batchDeleteAutomobiles() {
        try {
            this.loading = true;
            await Webapi.batchDeleteAutomobiles({
                automobileIds: this.selectionList.map((a) => a.automobileId),
            });
            this.$message({
                customClass: 'success-message',
                message: this.$t('deletedSuccessfully'),
                type: 'success',
                showClose: true,
            });
            this.refreshList();
        }
        catch (error) {
            console.log('batchDeleteAutomobiles error', error);
            this.loading = false;
        }
    }
    handleBatchDeleteFunc() {
        if (this.loading)
            return;
        this.$elconfirm(`${this.$t('deleteVehicleTip')}`, `${this.$t('tip')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.cancel')}`,
            confirmButtonText: ` ${this.$t('common.confirm')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    this.batchDeleteAutomobiles();
                }
            },
        });
    }
};
__decorate([
    Watch('paginationParams', { deep: true })
], default_1.prototype, "paginationParamsChange", null);
default_1 = __decorate([
    Component({
        i18n: {
            messages: lang,
        },
        components: {
            InputSearch,
            VehicleTable,
            SecondCertification,
            AuthNewitem,
        },
    })
], default_1);
export default default_1;
